<template>
  <div class="app">
    <div class="site-container">
      <notifications></notifications>
      <main id="main-content" class="main-content">
        <div class="horizontal-navbar">
          <div class="navbar-wrap">
            <div class="navbar-button">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>

            <h1 class="page-title">
              <router-link class="navbar-title" to="/">
                {{ $t('title') }}
              </router-link>
            </h1>
            <div class="nav-items">
              <div class="dropdown btn-group b-dropdown nav-item">
                <a href="#" class="dropdown-toggle nav-link" aria-haspopup="true" aria-expanded="true">
                  <span class="icon sli-user"></span>
                </a>

                <div class="dropdown-menu mini-menu">
                  <ul>
                    <li>
                      <router-link class="navbar-item" to="/balance">
                        <span class="dropdown-item icon sli-wallet"></span>
                        {{ $t('navbar.credit') + ': ' + walletCreditFormatted + ' ' + $t('balance_unit') }}
                        <span class="dropdown-item icon sli-refresh" @click="refreshWallet"></span>
                      </router-link>
                    </li>
                    <li v-if="false">
                      <router-link class="navbar-item" to="/profile">
                        <span class="dropdown-item icon sli-user"></span>
                        {{ $t('navbar.profile') }}
                      </router-link>
                    </li>
                    <li>
                      <router-link class="navbar-item" to="/login">
                        <span class="dropdown-item icon sli-power"></span>
                        {{ $t('navbar.logout') }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="items-overlay"></div>
            </div>
          </div>
        </div>

        <div class="main-content-wrap">
          <section class="section" style="height:100%">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </section>
        </div>

        <footer class="app-footer">
          <div class="copyright">{{ $t('footer.copyright') }}</div>
          <div class="version">
            <div class="d-flex">
              <div class="p-2"><a href="https://nasirbp.ir/">{{ $t('footer.title') }}</a></div>
            </div>
          </div>
        </footer>
      </main><!-- .main-content -->
    </div><!-- .site-container -->
  </div><!-- .app -->
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
var $ = require('jQuery')

export default {
  components: {
  },
  created () {
    this.checkShowLogin()
  },
  mounted () {
    $('body').addClass('loaded')
    var isTouchDevice = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/)

    if (isTouchDevice) {
      $('body').addClass('touch-device')
    }

    if (!this.walletCreditFetched) {
      this.refreshWallet()
    }

    // Init menu
    var menu = $('.main-menu')
    menu.on('click', '.item-link', function (e) {
      var $this = $(this)
      var li = $this.parent()

      if (li.hasClass('has-sub')) {
        e.preventDefault()

        if (li.hasClass('active')) {
          li.removeClass('active')
        } else {
          menu.find('.menu-item').removeClass('active')
          li.addClass('active')
        }
      }
    })

    var nav = $('.nav-items')
    nav.on('click', '.nav-link', function (e) {
      var $this = $(this)
      var item = $this.parent()
      if (item.hasClass('dropdown')) {
        e.preventDefault()

        if (item.hasClass('show')) {
          item.removeClass('show')
        } else {
          nav.find('.nav-item').removeClass('show')
          item.addClass('show')
        }
      }
    })
    nav.on('click', '.items-overlay', function (e) {
      nav.find('.nav-item').removeClass('show')
    })
    nav.on('click', '.navbar-item', function (e) {
      nav.find('.nav-item').removeClass('show')
    })
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    ...mapGetters({
      walletCredit: 'account/walletCredit',
      walletCreditFetched: 'account/walletCreditFetched'
    }),
    walletCreditFormatted () {
      return this.$options.filters.tsformat(this.walletCredit)
    }
  },
  methods: {
    ...mapActions('account', ['checkShowLogin', 'wallet']),
    refreshWallet () {
      this.wallet()
    }
  }
}
</script>

<style lang="scss">
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.dashboard-panel {
  flex: 0 0 15rem !important;
}
.navbar {
  background-color: transparent;
}
.navbar-wrap {
  padding-left: 0 !important;
}
.navbar-item .fa {
  font-size: 20px !important;
}
.navbar-item .btn {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: 0 0;
  border: none;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: rgba(0,0,0,.3);
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 20px;
  height: 3.07692rem;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  outline: 0;
  padding: 0;
  -webkit-transition: color .2s ease-in-out;
  transition: color .2s ease-in-out;
  width: 3.07692rem;
}
.navbar-item .btn:hover {
    color: #000;
}
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  .navbar-title,
  .navbar-title:hover,
  .navbar-title:visited,
  .navbar-title:focus,
  .navbar-title:active {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/views/DashboardLayout.vue